import gql from 'graphql-tag';

export const LOOK_VERTICAL_STATE_QUERY = gql`
  query lookVerticalState {
    lookVerticalState @client {
      filter {
        organization
        name_Icontains
      }
      orderBy
    }
  }
`;
